import { compose, withProps } from "recompose";
import * as React from "react";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import { ConfigData } from "../config";

/**
 * This component Shows a map (this compoment doesn't rerender)
 */

interface SimpleMapComponentProps {
    config: ConfigData;
    zoom?: number;
    handleRef?: (ref: GoogleMap) => void
}

class SimpleMapComponent extends React.Component<SimpleMapComponentProps, any> {

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const zoom = this.props.zoom || 13;
        return (
            <GoogleMap
                ref={ref => {
                    if (ref && this.props.handleRef) {
                        this.props.handleRef(ref);
                    }
                }}
                defaultZoom={zoom}
                center={this.props.config.maps.startingLocation}
            >
                {this.props.children}
            </GoogleMap>
        )
    }
}

const EnhancedMap = compose<SimpleMapComponentProps, SimpleMapComponentProps>(
    withProps({
        containerElement: <div style={{ height: 400 }} />,
        mapElement: <div style={{ height: 400 }} />,
    }),
    withGoogleMap
)(SimpleMapComponent);

export default compose<any, SimpleMapComponentProps>(withProps((props: SimpleMapComponentProps) => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
    loadingElement: <div style={{ height: 400 }} />,
})), withScriptjs)(EnhancedMap);



// WEBPACK FOOTER //
// ./src/components/SimpleMapComponent.tsx